import Enumerable from "linq";
import { Document, ItemSet } from "..";
import {
  IItem,
  instanceOfINameDisplayable,
} from "../items";
import { IDocumentAlert } from "../IDocumentAlert";
import {
  ExternalValidateItemAlert,
  ExternalValidateDocumentAlert,
  ExternalValidateAlert,
  ExternalValidateUnknownAlert,
 } from "../alerts";
import { AbstractItemValidator } from "./AbstractItemValidator";
import { ExternalValidationResultAlert } from "../../../applications/documaker/domain/document";

export class ExternalValidationObjectValidator extends AbstractItemValidator {
  constructor(private readonly _detectedAlerts: ExternalValidationResultAlert[]) {
    super();
  }

  public validate(document: Document): IDocumentAlert[] {
    return this._detectedAlerts // _detectedAlertsが未指定の場合は取得失敗.(警告なしは空配列.)
      ? super.validate(document).concat(this.toDocumentAlerts()).concat(this.toUnknownAlerts(document.itemSets))
      : [
        new ExternalValidateAlert(),
      ];
  }

  private toDocumentAlerts(): IDocumentAlert[] {
    return Enumerable.from(this._detectedAlerts)
      .where(a => !a.id && !a.name) // idもnameも未指定の場合は文書警告として扱う.
      .select(a => new ExternalValidateDocumentAlert(a))
      .toArray();
  }

  protected toUnknownAlerts(itemSet: ItemSet[]): IDocumentAlert[] {
    return Enumerable.from(this._detectedAlerts)
      .where(a => (a.id || a.name) && Enumerable.from(itemSet).selectMany(s => s.items).all(b => !this.isMatched(a, b)))
      .select(a => new ExternalValidateUnknownAlert(a))
      .toArray();
  }

  protected validateItem(item: IItem, itemSetId: number): IDocumentAlert[] {
    return Enumerable.from(this._detectedAlerts)
      .where(a => this.isMatched(a, item))  // id/もしくは名称一致.(重複があった場合は特定できないので全部出す.)
      .select(a => new ExternalValidateItemAlert(itemSetId, item, a))
      .toArray();
  }

  private isMatched(alert: ExternalValidationResultAlert, item: IItem): boolean {
    if (!alert || !item) { // 念の為ガード.
      return false;
    }
    return (alert.id && item.id && (alert.id.toString() === item.id))                                 // ID一致.
      || (alert.name && instanceOfINameDisplayable(item) && (alert.name === item.getDisplayName()));  // 名称一致.
  }
}
